<!--Documentation can be found here https://refreshless.com/nouislider/-->
<script>
import {onMount, onDestroy} from 'svelte';
import {getNextInputId} from '../../helper/UIHelper';  
import noUiSlider from 'nouislider';


export let model;
export let entryList;

let uid = getNextInputId();
let slider;
const stepVal = (100/(entryList.length - 1));


onMount(()=>{
    slider = document.getElementById(uid);

    let startVal = [stepVal, stepVal * 2];
    if(model != null){
        startVal = getSliderValue(model);
    }
    // const range_all_sliders = {
    //     'min': 0,
    //     [two]: [20, stepVal],
    //     '40%': [40, stepVal],
    //     '60%': [60, stepVal],
    //     '80%': [80, stepVal],
    //     'max': 100
    // };

    let range_all_sliders = {};
    const listLength = entryList.length;
    for(var i = 0; listLength > i; i++){
        let entry = entryList[i];
        //First Item
        if(i == 0){
            range_all_sliders['min'] = 0;
        }//Last Item
        else if((i + 1) == (listLength)){
            range_all_sliders['max'] = 100;
        }
        else{
            range_all_sliders[`${stepVal * i}%`] = [stepVal * i, stepVal];
        }

    }


    noUiSlider.create(slider, {
        start: startVal,
        step: stepVal,
        behaviour: 'tap-drag',
        connect: true,
        range: range_all_sliders,
        pips: {
            mode: 'range',
            density: stepVal
        }
    });

    const parent = document.getElementById(uid);
    var slides = parent.getElementsByClassName("noUi-value");
    for (var i = 0; i < slides.length; i++) {
        const entry = entryList[i];
        const elem = slides.item(i);

        elem.innerText = entry.Text;
        if(entry.Hint != null)
            elem.setAttribute('title', entry.Hint);
    }

    // Binding signature
    slider.noUiSlider.on('set', onSliderSet);
})


    function onSliderSet(values, handle, unencoded, tap, positions) {
        model = getModelValue(unencoded);
    // values: Current slider values (array);
    // handle: Handle that caused the event (number);
    // unencoded: Slider values without formatting (array);
    // tap: Event was caused by the user tapping the slider (boolean);
    // positions: Left offset of the handles (array);
    }

    function getModelValue(valueArray){
        let rVal = [];
        for(let i = 0; valueArray.length > i; i++){
            rVal.push(valueArray[i]/stepVal)
        }
        return rVal;
    }

    function getSliderValue(model){
        let rVal = [];
        for(let i = 0; model.length > i; i++){
            rVal.push(model[i]*stepVal)
        }
        return rVal;
    }

    onDestroy(()=>{
        slider.noUiSlider.off();
    })


</script>


<div id={uid}></div>

<style>
/*DEFAULT style of component and customiaztion is defined in global.css */
</style>